module.exports = __webpack_public_path__ + "img/D.68eca7e6.png";